module.exports = __webpack_public_path__ + "img/Slice14-min.29b40de1.png";